<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted(){
      document.title = '农电云库后台管理系统'
    if(sessionStorage.getItem("token") === null){
      this.$toast("warning", '登录过期,请重新登录');
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss">
// 底部分页的高度在layout.scss中设置距离底部高度 qyl
.el-pagination{
  text-align: center;
  white-space: nowrap;
  padding: .02rem .05rem;
  // padding: 10px 0 ;
  // padding-bottom: 10px !important;
  // position: absolute;
  // left: 0;
  // right: 0;
  // bottom: 0;
  // background-color: #ffffff;
}
figure {
    display: block;
    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    img {
    width: 100%;
    border-style: none;
}
}


// .ql-editor {
//   white-space: normal !important;
// }
 
// .ql-container {
//   white-space: pre-wrap !important;
// }
// 功能指引蒙层透明度
#driver-highlighted-element-stage{
    background-color: rgba(255, 255, 255, 0.1)!important;
}
</style>
